import React, { useEffect, useMemo, useState } from 'react';
import DataGrid from '../../../../Core/Controls/Grid';
import { getAllBookingSchedule } from '../../../../Core/Services/ServiceAgent/Schedule/BookingReq';
import { EditButton, BreadCrumbs, formatters } from '../../../../Core/Controls';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import NoteIcon from '@material-ui/icons/Note';
import ServiceAgentScheduleBookingSection from '../BookingRequest/BookingSection';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import ScheduleNotes from '../../../InternalUser/Controllers/Vehicles/ScheduleVehicle/scheduleVehicleNotes';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import { AppStorage } from '../../../../Core/Basic/storage-service';

const modalgridStyle = {
    formatterEditBtn: { textAlign: 'center' }
};

const crumbs = [{ name: 'Home', path: '/' }, { name: 'Schedule' }, { name: 'Booking Requests', path: '/', active: true }];

const baseColumns = [
    { key: 'action', name: 'Action', width: 100, addFileUploaderIcon: true },
    { key: 'scheduleRequestedBookingDate', name: 'Requested', formatter: formatters.Date_DDMMYYYY },
    { key: 'agentOrderNo', name: 'Job Ref', width: 150 },
    { key: 'scheduleDateDue', name: 'Due', formatter: formatters.Date_DDMMYYYY },
    { key: 'scheduleRequestedBookingTimeSlot', name: 'Time Slot' },
    { key: 'scheduleEventName', name: 'Event' },
    { key: 'scheduleNightBooking', name: 'Night Booking' },
    { key: 'scheduleDeliverBefore', name: 'Deliver Before' },
    { key: 'scheduleCollectAfter', name: 'Collect After' },
    { key: 'vehicleRegNumber', name: 'Reg Number' },
    { key: 'customerCompanyName', name: 'Customer' },
    { key: 'depotName', name: 'Depot' }
];

const BookingRequests = (props) => {
    const [state, setState] = useState({ modalToggle: false, rowVehicleID: null, defectID: null, List: [], showLoader: true, isReload: null });
    const [openDialog, setOpenDialog] = useState({});
    let checkhaveAccess = AppStorage.getAllowAcces();

    useEffect(async () => {
        pullAllBookingSchedule();
    }, []);

    const pullAllBookingSchedule = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };

    const checkButton = (ev, label) => {
        setOpenDialog({ [label]: true });
        setState((st) => ({
            ...st,
            selectedRowData: ev,
            scheduleVehicleID: ev.scheduleVehicleID
        }));
    };

    const closeTheDialog = (res) => {
        setOpenDialog({});
        res && pullAllBookingSchedule();
    };

    const renderEdit = (data, row) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {row?.displayNotes === 'Y' && (
                    <CustomIconButton
                        icon={NoteIcon}
                        color="primary"
                        className="modal-btn-update "
                        onClick={() => {
                            checkButton(row, 'notes');
                        }}
                        toolTipTitle="Notes"
                    />
                )}
                {row?.displayBookingRequest === 'Y' && (
                    <CustomIconButton
                        icon={ConfirmationNumberIcon}
                        className="modal-btn-update "
                        color="primary"
                        onClick={() => {
                            checkButton(row, 'section');
                        }}
                        toolTipTitle="Booking Details"
                    />
                )}
            </div>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.key === 'action');
        if (actionCol) {
            actionCol.formatter = renderEdit;
        }
        return tempCols;
    }, []);

    let getUrl = `ServiceAgentSchedules?VehicleID=&Status=${1}`;

    return (
        <div className={!props.VehicleID ? `screen` : ''} style={{ marginTop: 8 }}>
            {!props.VehicleID && <BreadCrumbs crumbs={crumbs} />}

            {state.modalToggle ? (
                <h6>Update popup</h6>
            ) : (
                <GijgoGrid
                    dataConverter={(res) => ({
                        records: res.data.list,
                        total: res.data.total
                    })}
                    columns={columns}
                    getUrl={getUrl}
                    isReload={state.isReload}
                    idFieldName={`${checkhaveAccess?.CanUploadScheduleDocuments ? 'scheduleID' : null}`}
                    fileUploaderConfigName={`${checkhaveAccess?.CanUploadScheduleDocuments ? 'ScheduleDocumentsRequired' : null}`}
                    downloadBtnName="Booking Requests"
                />
            )}
            {openDialog.section ? (
                <DialogComp title="Booking Section" maxWidth="md" onClose={closeTheDialog}>
                    <ServiceAgentScheduleBookingSection
                        vehicleId={state.scheduleVehicleID}
                        scheduleId={state.selectedRowData.scheduleID}
                        onClose={() => closeTheDialog(true)}
                    />
                </DialogComp>
            ) : null}
            {openDialog.notes ? (
                <DialogComp title="Schedule Notes" maxWidth="md" onClose={closeTheDialog}>
                    <ScheduleNotes vehicleId={state.scheduleVehicleID} scheduleId={state.selectedRowData.scheduleID} onClose={closeTheDialog} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default BookingRequests;
